import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ExcelMaterialImport_ModuleContextService } from './ExcelMaterialImport.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_import_statuses_dd_ComponentContextService {
  private readonly moduleContext: ExcelMaterialImport_ModuleContextService;

  constructor(moduleContext: ExcelMaterialImport_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'import_statuses_dd',
      type: ComponentType.selector
    }
  }
}